/*
 * File: main.ts
 * File Created: 2023-11-27 03:22:24
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-03-02 15:48:01
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import {
    StringHelper,
    DateHelper,
    ObjectHelper,
    NumberHelper,
    QuickHelper,
    UIQuick,
    EnumHelper,
} from "@root/core";
import "./tags";
import * as Enums from "@/helpers/enums";

declare global {
    interface Window {
        enums: () => typeof Enums;
        quicks: () => ReturnType<(typeof UIQuick)["getInstanceMap"]>;
        StringHelper: StringHelper;
        NumberHelper: NumberHelper;
        DateHelper: DateHelper;
        ObjectHelper: ObjectHelper;
        QuickHelper: QuickHelper;
        EnumHelper: EnumHelper;
    }
}

window.enums = () => Enums;
window.quicks = () => UIQuick.getInstanceMap();
window.StringHelper = StringHelper;
window.NumberHelper = NumberHelper;
window.DateHelper = DateHelper;
window.ObjectHelper = ObjectHelper;
window.QuickHelper = QuickHelper;
window.EnumHelper = EnumHelper;
